// extracted by mini-css-extract-plugin
module.exports = {"container":"xFrpEJ","title":"_1rx2Ef","subtitle":"R0w-7s","subsubtitle":"_1Cukog"};